import React, { useState } from 'react';
import styled from 'styled-components';

const FAQContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 2rem;
  text-align: center;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Description = styled.p`
  font-size: 1.1rem;
  color: #4b5563;
  text-align: center;
  margin-bottom: 3rem;
  line-height: 1.6;
`;

const FAQItem = styled.div`
  border-radius: 12px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e5e7eb;
  
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-color: #d1d5db;
  }
`;

const Question = styled.button`
  width: 100%;
  padding: 1.5rem;
  text-align: left;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
  background: white;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s ease;
  
  &:hover {
    background: #f9fafb;
  }
`;

const Answer = styled.div`
  padding: 0 1.5rem;
  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: all 0.3s ease;
  background: white;
  border-top: ${({ isOpen }) => (isOpen ? '1px solid #e5e7eb' : '0')};
`;

const AnswerContent = styled.div`
  padding: 1.5rem 0;
  color: #4b5563;
  line-height: 1.6;
`;

const Icon = styled.span`
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  color: #3b82f6;
`;

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How do I get started with your service?",
      answer: "Getting started is easy! Simply sign up for an account, complete your profile, and you'll be ready to use all our features."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards, PayPal, and bank transfers. All transactions are securely processed."
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer: "Yes, you can cancel your subscription at any time. There are no cancellation fees, and you'll continue to have access until the end of your billing period."
    },
    {
      question: "How do I contact customer support?",
      answer: "Our customer support team is available 24/7. You can reach us through the in-app chat, email at support@example.com, or by phone at (123) 456-7890."
    },
    {
      question: "Is there a mobile app available?",
      answer: "Yes! Our mobile app is available for both iOS and Android devices. You can download it from the App Store or Google Play Store."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <FAQContainer>
      <Title>Frequently Asked Questions</Title>
      <Description>Find answers to common questions about our product and services.</Description>
      
      {faqs.map((faq, index) => (
        <FAQItem key={index}>
          <Question onClick={() => toggleFAQ(index)}>
            {faq.question}
            <Icon isOpen={activeIndex === index}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Icon>
          </Question>
          <Answer isOpen={activeIndex === index}>
            <AnswerContent>{faq.answer}</AnswerContent>
          </Answer>
        </FAQItem>
      ))}
    </FAQContainer>
  );
};

export default FAQ;